/* TRIO – Boutique */
(function () {
  'use strict';
  if (window.__trioShop) return;
  window.__trioShop = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toast(sec, msg) {
    var t = document.querySelector('.ts-toast');
    if (!t) return;
    t.querySelector('span').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-on'); }, 4000);
  }

  function counters(root) {
    root.querySelectorAll('[data-ts-count]').forEach(function (el) {
      var to = parseInt(el.textContent, 10); if (reduce || !to) return;
      var t0 = performance.now(); el.textContent = 0;
      (function s(now) { var p = Math.min(1, (now - t0) / 1200); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(s); })(t0);
    });
  }

  function cards(root) {
    root.querySelectorAll('.ts-card').forEach(function (c) {
      var btns = c.querySelectorAll('.ts-sw button'), name = c.querySelector('.ts-sw__name'),
          add = c.querySelector('.ts-add'), view = c.querySelectorAll('[data-ts-link]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (name) name.textContent = b.dataset.name;
          if (add) { add.dataset.id = b.dataset.id; add.disabled = b.dataset.available !== 'true'; add.textContent = add.disabled ? add.dataset.soldout : add.dataset.label; }
          view.forEach(function (a) { a.href = b.dataset.url; });
        });
      });
      if (add) add.addEventListener('click', function () {
        if (add.disabled) return;
        var label = add.dataset.label;
        add.disabled = true; add.textContent = add.dataset.adding;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(add.dataset.id, 10), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (x) { return x.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('.tw-hd__cart b').forEach(function (b) { b.textContent = cart.item_count; });
            document.querySelectorAll('.tw-hd__cart').forEach(function (a) { a.setAttribute('aria-label', 'Panier, ' + cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '')); });
            document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
            add.classList.add('is-done'); add.textContent = add.dataset.done;
            toast(c, c.dataset.title + ' a été ajoutée au panier.');
            setTimeout(function () { add.classList.remove('is-done'); add.textContent = label; add.disabled = false; }, 2200);
          })
          .catch(function () { add.textContent = add.dataset.error; setTimeout(function () { add.textContent = label; add.disabled = false; }, 2500); });
      });
    });
  }

  function init(root) { root = root || document; counters(root); cards(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
